export default __webpack_public_path__ + "static/media/meeru.1a828a45.png";